import { Fragment } from "react";
import TableCell from "@mui/material/TableCell";
import TranslationField from "../../../type/translationField";
import { useTranslation } from "react-i18next";
import { defaultLang, secondLang } from "../../../utils";

const RegisterTableItem: React.FC<{
  name_transes: TranslationField;
  type_transes: TranslationField;
  trees_count: number;
  dead_trees?: number;
}> = ({ name_transes, type_transes, trees_count, dead_trees }) => {
  const { i18n } = useTranslation();
  const name =
    name_transes?.[secondLang] === ""
      ? name_transes[defaultLang]
      : name_transes[secondLang];
  return (
    <Fragment>
      <TableCell>
        {i18n.language === secondLang ? name : name_transes[defaultLang]}
      </TableCell>
      <TableCell>
        {i18n.language === secondLang
          ? type_transes[secondLang]
          : type_transes[defaultLang]}
      </TableCell>
      <TableCell align="center">{trees_count}</TableCell>
      <TableCell align="center">{dead_trees}</TableCell>
    </Fragment>
  );
};

export default RegisterTableItem;
